/**
 * ChiusoPartnerFields — campi per lo stage `chiuso_partner`:
 * tipo partnership + note + piano pagamenti (riusa ChiusoFields).
 * ★ Fase 59.P2 — estratto da StageTransitionModal.jsx. Comportamento invariato.
 */
import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { ChiusoFields } from './ChiusoFields';
import i18n from '../../i18n';

// ★ 2026-07-29: Chiuso Partner — dropdown tipo partnership + note + payment plan
const PARTNERSHIP_TYPES_FE = [
  { key: 'affiliato', get label() { return i18n.t('stageTransition.pt.affiliato', 'Affiliato'); } },
  { key: 'broker', label: 'Broker' },
  { key: 'reseller', label: 'Reseller' },
  { key: 'joint_venture', label: 'Joint-venture' },
  { key: 'referral', label: 'Referral' },
  { key: 'altro', get label() { return i18n.t('stageTransition.pt.altro', 'Altro'); } },
];

export function ChiusoPartnerFields(props) {
  const { form, set } = props;
  return (
    <div className="space-y-3">
      <div className="rounded-md bg-teal-50 border border-teal-200 p-3 text-xs text-teal-900">
        {i18n.t('stageTransition.partnerIntro', 'Chiusura con partner (affiliato/broker/referral). Compila il tipo di partnership e il piano pagamenti.')}
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.partnershipType', 'Tipo partnership')} *</Label>
        <Select value={form.partnership_type} onValueChange={(v) => set('partnership_type', v)}>
          <SelectTrigger className="mt-1" data-testid="partnership-type-select">
            <SelectValue placeholder={i18n.t('stageTransition.selectPh', 'Seleziona…')} />
          </SelectTrigger>
          <SelectContent>
            {PARTNERSHIP_TYPES_FE.map((p) => (
              <SelectItem key={p.key} value={p.key}>{p.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.partnershipNotes', 'Note partnership')}</Label>
        <Textarea
          rows={2}
          value={form.partnership_notes}
          onChange={(e) => set('partnership_notes', e.target.value)}
          placeholder={i18n.t('stageTransition.partnershipNotesPh', 'Dettagli: percentuale, condizioni, referente, ecc.')}
          className="mt-1"
          data-testid="partnership-notes"
        />
      </div>
      <div className="pt-2 border-t">
        <Label className="text-xs uppercase tracking-wide font-semibold mb-2 block">
          Piano pagamenti (obbligatorio)
        </Label>
        <ChiusoFields {...props} />
      </div>
    </div>
  );
}
